<template>
  <div>
    {{ translate.result.manual.received }}
    <br />
    {{ translate.result.manual.instruction }}

    <div class="manual-card-wrapper">
      <distributor-card
        v-for="(item, index) in resellers"
        :key="index"
        :info="item"
      />
    </div>

    {{ translate.result.manual.whatsapp }}
    <br />
    <br />
    {{ translate.result.manual.thanks }}
  </div>
</template>

<script>
import DistributorCard from '../card/DistributorCard.vue';
export default {
  name: 'manual-result',
  props: {
    resellers: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DistributorCard,
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>

<style lang="css" scoped>
.manual-card-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
}
</style>
